<template lang="html">
  <div class="team_info">
    <div class="module" v-if="has_team">
      <div class="module-left">
        <!-- <ButtonGroup class="btn-group" shape="circle">
            <Button :type="name == 'bein' ? 'primary' : 'default'" @click="change('bein')">
                在职
            </Button>
            <Button :type="name == 'beout' ? 'primary' : 'default'" @click="change('beout')">
                离职
            </Button>
        </ButtonGroup> -->
        <p class="data-tip"><i class="iconfont">&#xe654;</i>信息源自网络，存在滞后及错误可能，以企业实际情况为准。如需对数据纠错或其他需求咨询，随时联系我们，客服咨询：17725143798</p>
        <div v-show="name == 'bein'" key="bein">
          <div class="tab-item">
            <Row class="row" :gutter="16">
              <Col span="12" v-for="(item, index) in team_in" :key="index">
                <div class="layout-card-box" :class="index == team_in_idx ? 'layout-card-active' : ''">
                  <div class="layout-card" @click="team_in_idx = index">
                    <div class="avatar_div">
                      <img v-if="item.logo_url" :src="item.logo_url | logo_show" />
                      <Avatar :class="{ avatar: true }" v-else>{{ item.name | firstname }}</Avatar>
                    </div>
                    <div :class="item.title ? 'layout-c-saround' : 'layout-c-jcenter'">
                      <div class="layout-normal">
                        <span class="title">{{item.name}}</span>
                      </div>
                      <div class="desc" v-if="item.title">
                        <span>{{item.title}}</span>
                      </div>
                    </div>
                    <div class="triangle-bottomright" v-if="index == team_in_idx">
                      <img :src="$store.state.static_img_url+'pic/select.png'" alt="">
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <Nothing v-if="team_in.length == 0 && !spinShow">
            <p>暂无团队信息</p>
          </Nothing>
        </div>
        <!-- <div v-show="name == 'beout'" key="beout">
          <div class="tab-item">
            <Row class="row" :gutter="16">
              <Col span="12" v-for="(item, index) in team_out" :key="index">
                <div class="layout-card-box" :class="index == team_out_idx ? 'layout-card-active' : ''">
                  <div class="layout-card" @click="team_out_idx = index">
                    <div class="avatar_div">
                      <img v-if="item.logo_url" :src="item.logo_url | logo_show" />
                      <Avatar :class="{ avatar: true }" v-else>{{ item.name | firstname }}</Avatar>
                    </div>
                    <div :class="item.title ? 'layout-c-saround' : 'layout-c-jcenter'">
                      <div class="layout-normal">
                        <span class="title">{{item.name}}</span>
                      </div>
                      <div class="desc" v-if="item.title">
                        <span>{{item.title}}</span>
                      </div>
                    </div>
                    <div class="triangle-bottomright" v-if="index == team_out_idx">
                      <img :src="$store.state.static_img_url+'pic/select.png'" alt="">
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <Nothing v-if="team_out.length == 0 && !spinShow">
            <p>暂无离职成员信息</p>
          </Nothing>
        </div> -->
      </div>
      <div class="module-right" v-if="detail.people_uid">
        <div class="layout-c-center">
          <div class="detail-avatar">
            <img v-if="detail.logo_url" :src="detail.logo_url | logo_show" />
            <Avatar :class="{ avatar: true }" v-else>{{ detail.name | firstname }}</Avatar>
          </div>
          <span class="detail-name">{{detail.name}}</span>
          <span class="detail-title" v-if="detail.title">{{detail.title}}</span>
        </div>
        <div class="p-info">
          <div><i class="iconfont-sm">&#xe63a;</i>{{detail.province | pc(detail.city, '暂无常驻地址')}}</div>
          <!-- <div><i class="iconfont-sm">&#xe635;</i>{{detail.tel | tel}}</div> -->
          <!-- <div><i class="iconfont-sm">&#xe635;</i>暂不公开</div> -->
          <!-- <div><i class="iconfont-sm">&#xe638;</i>{{detail.email | empty('暂无邮箱')}}</div> -->
          <div><i class="iconfont-sm">&#xe637;</i>{{detail.birthday_year | empty('暂无出生年')}}</div>
          <div><i class="iconfont-sm">&#xe631;</i>{{detail.is_returnee | isno('海归','非海归')}}</div>
          <div><i class="iconfont-sm">&#xe639;</i>{{detail.highest_edu | deal('highest_edu', 'name', '暂无学历信息')}}</div>
          <!-- <div>
            <i class="iconfont-sm" style="color:#0c68ab">&#xe640;</i>
            <i class="iconfont-sm" style="color:#00adef">&#xe643;</i>
            <i class="iconfont-sm" style="color:#2ec76a">&#xe641;</i>
            <i class="iconfont-sm" style="color:#ff582a">&#xe642;</i>
          </div> -->
        </div>
        <Divider dashed class="dashed" />
        <div class="summary">
          {{detail.desc | empty('暂无')}}
        </div>
        <!-- <div class="p-btn">
          <router-link :to="{ name: 'PeoDetail',params: {uid: detail.people_uid} }">
            <Button class="more-button" shape="circle">了解更多</Button>
          </router-link>
        </div> -->
      </div>
    </div>
    <div v-if="!has_team">
      <Nothing>
        <p>暂无团队信息</p>
      </Nothing>
    </div>
    <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
  </div>
</template>

<script>
import { entityDetail } from '../../../service'
import Nothing from '@/components/Nothing2'
export default {
  data() {
    return {
      name: 'bein',
      spinShow: true,
      params: {
        uid: this.$route.params.uid,
        type: 'team'
      },
      team_in: [],
      team_in_idx: 0,
      team_out: [],
      team_out_idx: 0,

      detail: {
        people_uid: '',
        nxfly:[],
        ntag: []
      },
      has_team: true
    }
  },
  components: {
    Nothing
  },
  methods: {
    async getDetail() {
      let res = await entityDetail(this.params, (error) => {
        this.$Message.error('请求错误！')
      })
      if(res.status == 'success') {
        if (res.team.length == 0) {
          this.has_team = false
        } else {
          this.$set(this.$data, 'team_in', res.team)
          // this.$set(this.$data, 'team_in', res.team.filter((item) => {return item.state == '1'}))
          // this.$set(this.$data, 'team_out', res.team.filter((item) => {return item.state == '0' || item.state == null}))
          if (this.team_in.length != 0) {
            this.$emit('callbackData', 'TeamInfo')
            this.$set(this.$data, 'detail', this.team_in[0])
          }
          // console.log(this.detail)
        }
      } else {
        this.$Message.error(res.msg)
      }
      this.spinShow = false
    },
    change(name) {
      this.$set(this.$data, 'detail', '')
      if (name == 'bein') {
        if (this.team_in.length != 0) {
          this.$set(this.$data, 'detail', this.team_in[this.team_in_idx])
        }
      } else {
        if (this.team_out.length != 0) {
          this.$set(this.$data, 'detail', this.team_out[this.team_out_idx])
        }
      }
      this.name = name
    }
  },
  created() {
    this.getDetail()
  },
  watch: {
    team_in_idx(val) {
      this.$set(this.$data, 'detail', this.team_in[val])
    },
    team_out_idx(val) {
      this.$set(this.$data, 'detail', this.team_out[val])
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
</style>
